import { switchMap } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { QueryType } from 'app/enums/query-type.enum';
import { TeaserItem } from 'app/interfaces/teaser-item.model';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { ElasticSearchResult } from 'app/interfaces/elastic-search-result.model';
import { SearchService } from 'app/modules/search-module/services/search.service';

@Component({
  selector: 'app-detail-search',
  templateUrl: './detail-search.component.html',
  styleUrls: ['./detail-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailSearchComponent implements OnInit {
  $loadingResults: BehaviorSubject<boolean> = new BehaviorSubject(true);
  $results: Observable<ElasticSearchResult>;
  $currentPage: Subject<number> = new Subject<number>();
  details = [];
  aggregations = [];
  currentPage = 1;
  size = 24;
  settings: any = { hits: { total: 0 } };
  filterBody: any = { filters: {} };
  q: string;
  t: any;

  constructor(private searchService: SearchService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.$currentPage.subscribe(a => {
      this.currentPage = a;
      this.loadDetails(this.size, this.size * (this.currentPage - 1));
    });

    if (this.route !== null) {
      this.route.params
        .pipe(
          switchMap((params: Params) => {
            this.$currentPage.next(+params['page']);
            return this.$currentPage;
          })
        )
        .subscribe(a => {
          this.loadDetails(this.size, this.size * (this.currentPage - 1));
        });
    }
  }

  keyUp($event: KeyboardEvent) {
    if ($event.keyCode === 13) {
      return;
    }

    if (this.t) {
      clearTimeout(this.t);
    }

    this.t = setTimeout(() => {
      this.filter();
    }, 300);
  }

  loadDetails(size, from, queries = null) {
    this.$results = this.searchService.getDetails(size, from, queries);

    this.$results.subscribe(a => {
      this.details = a.hits;
      this.settings.hits.total = a.hitcount;

      // if (this.aggregations.length <= 0) {
      this.fillAggregations(a.aggregations);

      this.aggregations.sort((a: any, b: any) => {
        if (a.Meta.order < b.Meta.order) {
          return -1;
        } else if (a.Meta.order > b.Meta.order) {
          return 1;
        } else {
          return 0;
        }
      });

      this.$loadingResults.next(false);
    });
  }

  fillAggregationsRecursive(aggs: any[], dest: any[]): any[] {
    // tslint:disable-next-line:forin
    for (const x in aggs) {
      const a = aggs[x];
      if (a.Meta && (Object.getOwnPropertyNames(a).indexOf('Items') >= 0 || Object.getOwnPropertyNames(a).indexOf('Value') >= 0)) {
        dest = [...dest, a];
      } else {
        dest = this.fillAggregationsRecursive(a.Aggregations, dest);
      }
    }
    return dest;
  }

  fillAggregations(aggs: any[]) {
    const newAggregations = this.fillAggregationsRecursive(aggs, []);
    this.aggregations = Object.assign([], this.aggregations, newAggregations);

    if (this.filterBody) {
      // tslint:disable-next-line:forin
      for (const a in this.filterBody.filters) {
        const filter = this.filterBody.filters[a];
        const aggMatch = this.aggregations[this.aggregations.map(b => b.Meta.title).indexOf(filter.Field)];
        aggMatch.selectedValues = filter.Values;
        aggMatch.Items.forEach(i => (i.checked = filter.Values.indexOf(i.Key) >= 0));
      }
    }
  }

  filter() {
    this.$loadingResults.next(true);

    //reset page to page 1 by filtering results
    //this.currentPage = 1;

    let queries = null;
    if (this.filterBody && this.filterBody.filters) {
      queries = [];
      // tslint:disable-next-line:forin
      for (const prop in this.filterBody.filters) {
        queries.push(this.filterBody.filters[prop]);
      }
    }

    if (this.q) {
      if (!queries) {
        queries = [];
      }
      queries.push({
        Type: QueryType.QUERY,
        Field: 'q',
        Values: [this.q],
      });
    }
    // else if (Object.keys(this.filterBody.bool).indexOf('must') >= 0) {
    //   delete this.filterBody.bool.must;
    // }

    this.loadDetails(this.size, 0, queries);
  }
}
